import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'SM',
  name: 'S.M.',
  role: 'Spanish Teacher — Chicago, IL',
  text: '"I no longer spend my Sunday nights building lessons from scratch. I open the system, choose the lesson and walk in completely prepared. My students feel the difference — and so do I."'
}, {
  initials: 'CV',
  name: 'C.V.',
  role: 'Spanish Teacher — Miami, FL',
  text: '"The emergency lessons saved me three times in the first month alone. That bonus is worth the full price by itself."'
}, {
  initials: 'JR',
  name: 'J.R.',
  role: 'Spanish Teacher — Houston, TX',
  text: '"The grammar guide changed the way I explain concepts. My explanations are clearer, my students understand faster and I spend zero time writing examples from scratch."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-dark-card border-y border-navy-border bg-navy-card" data-id="element-294">
      <div className="max-w-7xl mx-auto px-4" data-id="element-295">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-296">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-black border border-gold/20 p-6 rounded-2xl relative" data-id="element-297">
              <div className="flex gap-1 text-gold mb-4" data-id="element-298">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-299" />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-300">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-301">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-302">
                  {t.initials}
                </div>
                <div data-id="element-303">
                  <div className="font-bold text-white text-sm" data-id="element-304">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-305">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}